import { memo } from 'react';
import { Table } from 'src/components/ui-components';

export const MemoizedTableColGroupColumn = memo(() => <Table.Col colWidth={70} />);
